import { render, staticRenderFns } from "./ResultadoExportacaoProtheus.vue?vue&type=template&id=41cfaa13&scoped=true"
import script from "./ResultadoExportacaoProtheus.vue?vue&type=script&setup=true&lang=js"
export * from "./ResultadoExportacaoProtheus.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cfaa13",
  null
  
)

export default component.exports